import { useQueryClient } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'

import { type FillApplicationState, invalidateFillApplication } from '@/models/fillApplication'
import type { Org } from '@/models/user'

/** Refetches the customer when the page state names an owner their payload doesn't, e.g. one Intake just linked. */
export function useRefreshOrgOnOwnerLink(org: Org, state: FillApplicationState | undefined) {
  const queryClient = useQueryClient()
  const shown = org.currentInsuranceApplication?.businessOwner?.id ?? null
  const linked = state ? state.businessOwnerId : undefined
  const refreshedFor = useRef<string | null | undefined>(undefined)

  useEffect(() => {
    if (linked === undefined || linked === shown || refreshedFor.current === linked) return
    refreshedFor.current = linked
    void invalidateFillApplication(queryClient, org.id, { state: false })
  }, [linked, shown, org.id, queryClient])
}
